import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import WatermarkRemoval from './pages/WatermarkRemoval';
import BackgroundRemoval from './pages/BackgroundRemoval';
import ImageCompression from './pages/ImageCompression';
import FormatConversion from './pages/FormatConversion';
import ImageToPdf from './pages/ImageToPdf';
import AIGeneration from './pages/AIGeneration';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/watermark-removal" element={<WatermarkRemoval />} />
            <Route path="/background-removal" element={<BackgroundRemoval />} />
            <Route path="/compress" element={<ImageCompression />} />
            <Route path="/convert" element={<FormatConversion />} />
            <Route path="/image-to-pdf" element={<ImageToPdf />} />
            <Route path="/ai-generate" element={<AIGeneration />} />
          </Routes>
        </main>
        <Footer />
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </Router>
  );
}

export default App;
